import Component from './message_history_filter.vue'
export default Component
